import type { CarrierDisplayField } from '@satellite/composables/useCarrierDisplayV2';

/**
 * Display fields for {@link CompanyPresenterV2}.
 *
 * Company fields use short names (`name`, `scac`). Carrier-person fields are prefixed
 * (`carrierName`, `carrierEmail`, `carrierPhone`) because this presenter is
 * company-centric and `name` refers to the company, not the carrier contact.
 */
export type CompanyDisplayField = 'carrierName' | 'carrierEmail' | 'carrierPhone' | 'name' | 'scac';

const COMPANY_TO_CARRIER_DISPLAY_FIELD: Record<CompanyDisplayField, CarrierDisplayField> = {
  carrierName: 'name',
  carrierEmail: 'email',
  carrierPhone: 'phone',
  name: 'companyName',
  scac: 'companyScac'
};

export function mapCompanyDisplayFieldsToCarrier(
  displayFields: readonly CompanyDisplayField[]
): CarrierDisplayField[] {
  return displayFields.map(field => COMPANY_TO_CARRIER_DISPLAY_FIELD[field]);
}
